

class PlasError {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		this.id = jsonData.id;
		this.time = jsonData.time;
		this.service = jsonData.service;
		this.operation = jsonData.operation;
		this.parameters = JSON.parse(jsonData.parameters);
		this.output = JSON.parse(jsonData.output);

		this.userId = this.parameters.userId;
	}

}

export { PlasError }
